const state = {
  login: {
    token: false,
    member_id: null,
    organization_id: null,
    is_official: false,
    is_event_creator: false,
    is_resident: false,
    unreads: 0,
    unapproved_events: 0,
    expire: 0,
  },
}

const getters = {
  getLogin: (state) => state.login,
  getLoginToken: (state) => state.login.token,
  getLoginMemberID: (state) => state.login.member_id,
  getLoginOrganizationID: (state) => state.login.organization_id,
  isOfficial: (state) => state.login.is_official,
  isEventCreator: (state) => state.login.is_event_creator,
  isResident: (state) => state.login.is_resident,
  isExpired: (state) => state.login.expire < new Date().getTime(),
  getUnreads: (state) => state.login.unreads,
  getUnapprovedEvents: (state) => state.login.unapproved_events,
  hasUnreads: (state) => state.login.unreads > 0,
  hasUnapprovedEvents: (state) => state.login.unapproved_events > 0,
}

const mutations = {
  saveUnreads: (state, unreads) => {
    state.login.unreads = unreads
  },
  saveUnapprovedEvents: (state, unapproved_events) => {
    state.login.unapproved_events = unapproved_events
  },
  saveLoginInfo: (state, login) => {
    state.login.token = login.token
    state.login.member_id = login.member_id
    state.login.organization_id = login.organization_id
    state.login.is_official = login.is_official
    state.login.is_event_creator = login.is_event_creator
    state.login.is_resident = login.is_resident
    state.login.unreads = login.unreads
    state.login.unapproved_events = login.unapproved_events
    state.login.expire = Math.floor(1000 * login.expire)
    if (state.login.name) {
      delete state.login.name
    }
  },
}

const actions = {
  setUnreads({ commit }, unreads) {
    commit('saveUnreads', unreads)
  },
  setUnapprovedEvents({ commit }, unapproved_events) {
    commit('saveUnapprovedEvents', unapproved_events)
  },
  setLoginInfo({ commit }, login) {
    commit('saveLoginInfo', login)
  },
  unsetLoginInfo({ commit }) {
    commit('saveLoginInfo', {
      token: false,
      member_id: null,
      organization_id: null,
      is_official: false,
      is_event_creator: false,
      is_resident: false,
      unreads: 0,
      unapproved_events: 0,
      expire: 0,
    })
  },
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
}
